import { BookUser, PackageCheck, LifeBuoy } from "lucide-react";
import { ContattiIcon } from "../icone-utility/IcoCont";
import BackOrderIcon from "../icone-utility/IcoBO";
import TicketIcon from "../icone-utility/IcoTicket";
import RitiriIcon from "../icone-utility/IcoRitiri";

export const utilityServices = [
  {
    title: "Contatti",
    desc: "Rubrica aziendale",
    icon: ContattiIcon,
    route: "/utility/add-contatti",
  },
  {
    title: "Back Order",
    desc: "Ordini in arretrato",
    icon: BackOrderIcon,
    route: "/utility/backorder",
  },
  {
    title: "Ticket",
    desc: "Assistenza e supporto",
    icon: TicketIcon,
    route: "/utility/ticket",
  },
  {
    title: "Ritiri",
    desc: "Gestione ritiri",
    icon: RitiriIcon,
    route: "/utility/ritiri",
  },
];